module.exports = __webpack_public_path__ + "img/trunk_9x1_z18.78cedd20.svg";